// extracted by mini-css-extract-plugin
module.exports = {"body":"DowngradeConfirmation_body__3oqD0","button_primary":"DowngradeConfirmation_button_primary__2pZVm","modal":"DowngradeConfirmation_modal__2pmvw"};